import { useTranslation } from 'react-i18next';
import Card from '../../../components/base/Card';

export default function FeaturesSection() {
  const { t } = useTranslation();
  
  const features = [
    {
      icon: 'ri-flashlight-line',
      titleKey: 'features.instant.title',
      descKey: 'features.instant.desc',
      image: 'https://public.readdy.ai/ai/img_res/4b8e6b5b60d8a0ae8dc7c1404fa370e6.jpg'
    },
    {
      icon: 'ri-shield-check-line',
      titleKey: 'features.seamless.title',
      descKey: 'features.seamless.desc',
      image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20user%20interface%20dashboard%20with%20cryptocurrency%20trading%20elements%2C%20seamless%20user%20experience%20design%2C%20professional%20blue%20gradient%20background%2C%20intuitive%20navigation%20and%20smooth%20workflow%20visualization&width=400&height=300&seq=seamless-ux&orientation=landscape'
    },
    {
      icon: 'ri-award-line',
      titleKey: 'features.peace.title',
      descKey: 'features.peace.desc',
      image: 'https://readdy.ai/api/search-image?query=Security%20shield%20with%20cryptocurrency%20symbols%2C%20trust%20and%20safety%20concept%2C%20professional%20financial%20regulation%20badges%2C%20secure%20digital%20vault%20with%20Bitcoin%20and%20blockchain%20elements%2C%20blue%20and%20gold%20color%20scheme&width=400&height=300&seq=peace-mind&orientation=landscape'
    },
    {
      icon: 'ri-bank-card-line',
      titleKey: 'features.payment.title',
      descKey: 'features.payment.desc',
      image: 'https://readdy.ai/api/search-image?query=Credit%20card%20payment%20transaction%20with%20digital%20money%20transfer%2C%20secure%20online%20payment%20processing%2C%20modern%20banking%20interface%20with%20cryptocurrency%20elements%2C%20professional%20financial%20technology%20design%20with%20blue%20and%20green%20gradient%20background&width=400&height=300&seq=payment-transaction&orientation=landscape'
    },
    {
      icon: 'ri-shield-star-line',
      titleKey: 'features.fraud.title',
      descKey: 'features.fraud.desc',
      image: 'https://readdy.ai/api/search-image?query=Advanced%20cybersecurity%20protection%20with%20digital%20shield%2C%20fraud%20prevention%20technology%2C%20secure%20cryptocurrency%20transactions%2C%20modern%20security%20algorithms%20visualization%2C%20professional%20blue%20and%20green%20color%20scheme&width=400&height=300&seq=fraud-protection&orientation=landscape'
    },
    {
      icon: 'ri-customer-service-2-line',
      titleKey: 'features.support.title',
      descKey: 'features.support.desc',
      image: 'https://readdy.ai/api/search-image?query=24%2F7%20customer%20support%20team%20with%20headsets%2C%20round-the-clock%20assistance%20concept%2C%20professional%20customer%20service%20representatives%2C%20modern%20help%20desk%20environment%20with%20cryptocurrency%20trading%20elements&width=400&height=300&seq=support-247&orientation=landscape'
    }
  ];

  return (
    <section className="py-20 bg-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-black text-white mb-6">
            {t('features.title')}
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            {t('features.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <Card key={index} hover className="text-center">
              <div className="mb-6">
                <img 
                  src={feature.image} 
                  alt={t(feature.titleKey)}
                  className="w-full h-48 object-cover rounded-lg mb-4"
                />
                <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto">
                  <i className={`${feature.icon} text-2xl text-white`}></i>
                </div>
              </div>
              <h3 className="text-xl font-semibold text-white mb-4">{t(feature.titleKey)}</h3>
              <p className="text-gray-400 leading-relaxed">{t(feature.descKey)}</p>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}